import { IGetAccessCodeResponse } from 'api/components/Auth/types';

import * as actionTypes from './actionTypes';

import { IAuthByCWT, IBaseAuth, ISendTemporaryPasswordAction, ISignInRequest } from './types';

export const authentication = ({ onError, onSuccess, isOldTypeToken, isTokenFromUrl }: IBaseAuth) => {
    return {
        type: actionTypes.AUTHENTICATE,
        payload: {
            onError,
            onSuccess,
            isOldTypeToken,
            isTokenFromUrl,
        },
    } as const;
};

export const authenticateByCWTToken = (payload: IAuthByCWT) => {
    return {
        type: actionTypes.AUTHENTICATE_BY_CWT_TOKEN,
        payload,
    } as const;
};

export const setAuthenticationStatus = (isAuthenticated: boolean) => {
    return {
        type: actionTypes.SET_AUTHENTICATION_STATUS,
        payload: isAuthenticated,
    } as const;
};

export const setAuthRedirectUrl = (pathname: string | null) => {
    return {
        type: actionTypes.SET_AUTHENTICATION_REDIRECT_URL,
        payload: pathname,
    } as const;
};

export const signInRequest = (payload: ISignInRequest) => {
    return {
        type: actionTypes.SIGN_IN_REQUEST,
        payload,
    } as const;
};

export const signInSuccess = () => {
    return {
        type: actionTypes.SIGN_IN_SUCCESS,
    } as const;
};

export const signInError = () => {
    return {
        type: actionTypes.SIGN_IN_ERROR,
    } as const;
};

export const logout = () => {
    return {
        type: actionTypes.LOG_OUT,
    } as const;
};

export const setAuthTokenAccess = (payload: string | null) => {
    return {
        type: actionTypes.SET_AUTH_TOKEN_ACCESS,
        payload,
    } as const;
};

export const sendTemporaryPassword = (payload: ISendTemporaryPasswordAction) => {
    return {
        type: actionTypes.SEND_TEMPORARY_PASSWORD_REQUEST,
        payload,
    } as const;
};

export const sendTemporaryPasswordSuccess = () => {
    return {
        type: actionTypes.SEND_TEMPORARY_PASSWORD_SUCCESS,
    } as const;
};

export const sendTemporaryPasswordError = () => {
    return {
        type: actionTypes.SEND_TEMPORARY_PASSWORD_ERROR,
    } as const;
};

export const setAuthTokenWellFunnel = (payload: string | null) => {
    return {
        type: actionTypes.SET_AUTH_TOKEN_WELLFUNNEL,
        payload,
    } as const;
};

export const setAuthTokenRefresh = (payload: string | null) => {
    return {
        type: actionTypes.SET_AUTH_TOKEN_REFRESH,
        payload,
    } as const;
};

export const getAppAccessCodeRequest = () => {
    return {
        type: actionTypes.GET_APP_ACCESS_CODE_REQUEST,
    } as const;
};

export const getAppAccessCodeSuccess = (payload: IGetAccessCodeResponse) => {
    return {
        type: actionTypes.GET_APP_ACCESS_CODE_SUCCESS,
        payload,
    } as const;
};

export const getAppAccessCodeFailure = () => {
    return {
        type: actionTypes.GET_APP_ACCESS_CODE_FAILURE,
    } as const;
};

export const getAuthTokenRequest = () => {
    return {
        type: actionTypes.GET_AUTH_TOKEN_REQUEST,
    } as const;
};

export const getAuthTokenSuccess = (payload: string) => {
    return {
        type: actionTypes.GET_AUTH_TOKEN_SUCCESS,
        payload,
    } as const;
};

export const getAuthTokenError = () => {
    return {
        type: actionTypes.GET_AUTH_TOKEN_ERROR,
    } as const;
};
